import React from 'react'

import { Container } from '../../../../../components'
import { BaseProps } from '../types'
import { LeaseCluster } from '../../../../../models'
import { typographyStyle } from '../../../../../theme/typographyStyle'

interface Props extends BaseProps {
    leaseCluster: LeaseCluster
    onClick: (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        leaseCluster: LeaseCluster,
    ) => void
}

export const EventTypeMoveIn = (props: Props) => {
    const { theme, leaseCluster } = props

    return (
        <Container
            style={{ alignItems: 'center' }}
            onClick={(e) => props.onClick(e, leaseCluster)}
        >
            <span
                style={{
                    ...typographyStyle(theme.typography.body2),
                    fontWeight: 500,
                }}
            >
                {leaseCluster.count} Move Ins
            </span>
        </Container>
    )
}
